import { Inject, Injectable } from '@angular/core';
import { Role } from '@models/role.model';
import { NgxCrudService } from '@sinapsys/ngx-crud';
import { Observable, map } from 'rxjs';
import { COMMON_APP_CONFIG } from '../tokens/common-config.token';

@Injectable({
  providedIn: 'root',
})
export class RolesService extends NgxCrudService<Role, number> {
  constructor(@Inject(COMMON_APP_CONFIG) private mainConfig: Required<{ api: { apiBaseUrl: string } }>) {
    super({ apiBaseUrl: '' });
    this._baseUrl += this.mainConfig.api.apiBaseUrl + 'settings/roles/';
  }

  getAutocomplete(sq: string): Observable<Role[]> {
    return this.search({ $or: { email: { $like: sq }, firstName: { $like: sq }, lastName: { $like: sq } } }).pipe(
      map((c) => c.items.map((c) => new Role(c)))
    );
  }
}
